import Vue from 'vue'
import Vuex from 'vuex'
import {app} from './main'
import router from "./router"
import modules from '@/vuex/modules'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    currentUser: {
    }
  },
  mutations: {
    // Config multiple language
    setLang: (state, payload) =>{
      app.$i18n.locale = payload
    },

    // Set Current User information
    setCurrentUser: (state, payload) => {
      if (!payload.avatar) payload.avatar = require("@/assets/images/1.jpg")
      state.currentUser = payload
    }
  },
  actions: {

    // Config multiple language
    setLang: (context, payload) => {
      context.commit("setLang", payload)
    },

    // Set Current User information
    setCurrentUser: (context, payload) => {
      context.commit("setCurrentUser", payload)
    },

    // Logout
    logout: () => {
      Vue.cookie.delete("ahaTokenAdmin")
      router.push("/pages/login")
    }
  },
  modules,
})
